import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import axios from "axios"
import logo from '../images/logo_RT132.png';
import { ReactComponent as Arrow } from "../assets/arrow.svg"

import InitiativesCard from "../components/home/Initiatives/InitiativesCard"
import Title from "../components/global/Title/Title"
import Content from "../components/global/Content/Content"
import Animation from "../components/global/Animation/Animation"

import { Loader } from "../components/common/Loader/Loader"

export default class InitiativesTemplate extends Component {
  constructor(props){
    super(props);
    this.state = {
      loading: false,
      error: '',
      data: [],
      dataAll: [],
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.setState({loading: true})
    axios.all([
      axios.get(`/wp-json/wp/v2/pages/111`),
      axios.get(`/wp-json/wp/v2/initiatieven?per_page=100`)
    ])
    .then(axios.spread((resData, resDataAll) => {
      this.setState({
        data: resData.data,
        dataAll: resDataAll.data,
        loading: false
      })
    }))
    .catch(error => {
      console.log(error)
    });
  }

  render() {
    const { data, dataAll, loading } = this.state
    return (
      loading === true ? <Loader/> :
      <div>
        <Helmet>
          <title>{data.yoast_title && data.yoast_title}</title>
          <meta name={data.yoast_meta && data.yoast_meta[0].name} content={data.yoast_meta && data.yoast_meta[0].content} />
        </Helmet>
        <section className="relative p-0 pt-16">
          <Animation/>
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 md:flex md:flex-wrap lg:px-8 z-10 relative">
            <div className="ml-1-col w-3/4 py-32">
              <div className="breadcrumb-bar" style={{color: "#F58120"}}>
                <div className="breadcrumb"><Link to="/">Home</Link><div className="px-2 breadcrumb-seperator"><Arrow/></div></div>
                <div className="breadcrumb" style={{color: "#000"}}>{ data.title && data.title.rendered }</div>
              </div>
              <Title level="1" className="underlined">{ data.title && data.title.rendered }</Title>
              <Content className="mt-10 xs:w-full w-2/3">{ data.content && data.content.rendered }</Content>
            </div>
            <div className="w-full md:mx-1-col">
              <div className="md:-mx-2">
                {dataAll && dataAll.map(prop => {
                  return (
                    <div key={prop.id} className="w-full inline-block md:w-6/12 lg:w-6/12 px-4 my-4">
                      <InitiativesCard title={prop.title && prop.title.rendered} label={prop.date} link={`/${prop.type}/${prop.slug}/`} imageSrc={prop.better_featured_image ? prop.better_featured_image.source_url : logo}/>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
